
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/defi/make-money-on-BUSD-via-AlpacaFinance",
      function () {
        return require("private-next-pages/defi/make-money-on-BUSD-via-AlpacaFinance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/defi/make-money-on-BUSD-via-AlpacaFinance"])
      });
    }
  